import { z } from 'zod'

export const K8sNamespaceInfo = z.object({
  id: z.number(),
  namespace: z.string(),
  status: z.enum([
    'provisioning',
    'active',
    'failed',
    'deprovisioning',
    'deprovisioned',
    'suspended'
  ]),
  billing_type: z.enum(['payg', 'fixed', 'free']),
  product_name: z.string().optional(),
  product_slug: z.string().optional(),
  tier: z.enum(['free', 'paid']).optional(),
  suspended_at: z.number().nullable().optional(),
  suspended_reason: z.string().nullable().optional(),
  egress_used_gib: z.number().nullable().optional(),
  inactivity_warned_at: z.number().nullable().optional()
})

export type K8sNamespaceInfoType = z.infer<typeof K8sNamespaceInfo>
